import BaseService from '@/network/base-service'

class NewRegisterService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/auth/Auth`)
  }

  newRegister (userName, userCpf, userEmail, userCel, userPassword, emailConfirmation) {
    const payload = {
      Nome: userName,
      CPF: userCpf,
      Email: userEmail,
      Celular: userCel,
      Senha: userPassword,
      confirmaporemail: emailConfirmation
    }

    const config = {
      headers: {
        'Authorization': 'Basic ' + btoa(`${payload.CPF}:${payload.Senha}`)
      }
    }
    return this.post('cadastrarusuario', payload, config)
  }

  validateRegister (code) {
    return this.post(`ValidarCadastro?code=${code}`)
  }
}

export default new NewRegisterService()
